<div [formGroup]="form" *ngIf="field.editable">
  <ng-container *ngIf="isEmailValue">
    <input
      class="form-control"
      [formControlName]="field.alias"
      type="text"
      [id]="'ba-'+ field.alias"
      [attr.disabled]="disabled ? '' : null"
      [ngClass]="{'is-invalid':!control.valid && (control.touched || control.dirty)}"
    />
    <span
      class="invalid-feedback"
      *ngIf="control.hasError('email') && (control.touched || control.dirty)">
        Enter a valid email address
    </span>
  </ng-container>
  <ng-container *ngIf="!isEmailValue">
    <input
      class="form-control"
      [formControlName]="field.alias"
      mask="{{maskExpression}}"
      type="text"
      [id]="'ba-'+ field.alias"
      [attr.disabled]="disabled ? '' : null"
      [ngClass]="{'is-invalid':!control.valid && (control.touched || control.dirty)}"
    />
    <span
      class="invalid-feedback"
      *ngIf="!valid && (control.touched || control.dirty)">
        Invalid
    </span>
  </ng-container>
</div>
<ng-container *ngIf="!field.editable && field.value">
  <div>
      {{ field.alias === 'date_signed' ? (field.value | date) : field.value }}
  </div>
</ng-container>
<ng-container *ngIf="!field.editable && !field.value">
  <div *ngIf="field.alias === 'date_signed'">
    Not Signed
  </div>
  <div *ngIf="field.alias !== 'date_signed'">
    Not Set
  </div>
</ng-container>
